import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container position-fixed breadcrumbs top-0 start-50 translate-middle-x p-0" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "progress position-absolute top-50 start-50 translate-middle w-100",
  style: {"height":"1px"}
}, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "progress-bar",
    role: "progressbar",
    "aria-valuenow": "25",
    "aria-valuemin": "0",
    "aria-valuemax": "100"
  })
], -1)
const _hoisted_3 = { class: "breadcrumb-wrapper d-none d-lg-block" }
const _hoisted_4 = { class: "nav nav-breadcrumbs justify-content-between my-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_nav_element = _resolveComponent("nav-element")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("ul", _hoisted_4, [
        _createVNode(_component_nav_element, {
          section: _ctx.WorkflowSection.EducationVideo
        }, null, 8, ["section"]),
        _createVNode(_component_nav_element, {
          section: _ctx.WorkflowSection.UserQuestions
        }, null, 8, ["section"]),
        _createVNode(_component_nav_element, {
          section: _ctx.WorkflowSection.UserCalculations
        }, null, 8, ["section"]),
        _createVNode(_component_nav_element, {
          section: _ctx.WorkflowSection.RiskInsights
        }, null, 8, ["section"]),
        _createVNode(_component_nav_element, {
          section: _ctx.WorkflowSection.FCAStatement
        }, null, 8, ["section"])
      ])
    ])
  ]))
}